/**
 * Users Hooks
 * React Query hooks for user listing via /users/complete
 */

import { useQuery } from '@tanstack/react-query';
import { usersApi } from '@/lib/api/users';
import type { UserCompleteListResponse, UserCompleteListParams } from '@/types/users';

/**
 * Query users for selection/targeting via /users/complete.
 * Supports search by username, nickname, phone, email, real name.
 */
export function useUsers(params?: UserCompleteListParams): ReturnType<typeof useQuery<UserCompleteListResponse>> {
  return useQuery({
    queryKey: ['users', 'complete', params],
    queryFn: () => usersApi.listUsersComplete(params),
  });
}
